import type { Package } from '$/entities/Package';

export function getPackageNameForHubSpot(pkg: Package) {
	return pkg ? pkg.name.replace(' (CAD)', '').replace(' (USD)', '') : 'Basic';
}
